<template>
    <div>
        <GenericPopups ref="GenericPopups"></GenericPopups>
        <ImageLightBox ref="ImageLightBox"></ImageLightBox>
        <b-row>
            <b-col cols="9">
                <b-row>
                    <b-col class="workspace-header">
                        <h1 class="text-right"><i class="fa-duotone fa-file-invoice-dollar fa-fw"></i> Offer Generation</h1>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col>
                        <b-card v-if="order" :header-class="previous_order_negotiated() ? 'offers-issue-color' : ''">
                            <template v-slot:header>
                                <OrderCardHeader :order="order"></OrderCardHeader>
                            </template>

                            <b-card header="Offer Generation Criteria" header-class="font-weight-bold">
                                <b-row>
                                    <b-col>
                                        <label><i class="fa-light fa-user-chart"></i> Customer Payout Rate</label>
                                        <div>
                                            {{ customer.payment_rate ? customer.payment_rate : '-' }}
                                        </div>
                                    </b-col>

                                    <b-col :class="_quoteFlag().id ? 'text-success' : ''" :title="_quoteFlag().note" v-b-tooltip.hover>
                                        <div>
                                            <label :class="_quoteFlag().id ? 'text-success' : ''"><i class="fa-light fa-comment-dollar" ></i> Quote</label>
                                        </div>

                                        <div class="d-inline-block" :class="order.offer_quote ? 'border' : '' ">
                                            <span v-if="order.offer_quote" class="font-weight-bold px-2">{{ order.offer_quote }}</span>

                                            <b-button v-if="_quoteFlag().id" size="sm" :variant="_quoteFlag().id ? 'success' : 'secondary'"
                                                      @click="activateFlag(_quoteFlag())">Show Details <i class="fa-light fa-plus"></i></b-button>
                                        </div>
                                    </b-col>

                                    <b-col>
                                        <label><i class="fa-light fa-badge-dollar"></i> 5% Bonus</label>
                                        <div>
                                            <i class="fas"
                                               :class="(order.bonus_override == '5' || order.bonus_card_present) ? 'fa-check-circle text-success' : 'fa-circle text-secondary' "></i>
                                        </div>
                                    </b-col>

                                    <b-col>
                                        <label><i class="fa-light fa-badge-dollar"></i> 10% Trust Sequence</label>
                                        <div>
                                            <i class="fas"
                                               :class="(order.bonus_override == '10' || order.trust_sequence_bonus) ? 'fa-check-circle text-success' : 'fa-circle text-secondary' "></i>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-card>

                            <b-card header="Inventory Items" header-class="font-weight-bold" header-tag="header"
                                    v-if="!loading && inventory">
                                    <template #header>
                                        <h6 class="mb-0 font-weight-bold float-left">Inventory Items</h6>

                                        <b-button-group class="float-right" size="sm">
                                            <b-button v-on:click="expandAll">
                                                <i class="fas fa-expand fa-fw"></i> Expand All
                                            </b-button>
                                            <b-button v-on:click="collapseAll">
                                                <i class="fas fa-compress fa-fw"></i> Collapse All
                                            </b-button>
                                        </b-button-group>
                                    </template>
                                <b-card v-for="(value, name, index ) in inventory" body-class="p-0" :key="index">
                                    <b-table :fields="inventoryFields" :items="inventory[name]"
                                             striped
                                             :tbody-tr-class="rowClass"
                                             thead-class="bg-dark"
                                             class="text-center mb-0 font-weight-bold">
                                        <template v-slot:thead-top="data">
                                            <b-tr class="table-header-bg">
                                                <b-th colspan="7" class="h4 text-left">
                                                    <template v-if="marketPrices">
                                                        <span v-if="(name == 'gold' || name == 'silver' || name == 'platinum' || name == 'palladium')"
                                                            v-b-tooltip.hover :title="`$${marketPrices[name]}`">{{ name | titleCase }}</span>

                                                        <span v-else-if="name === 'gold-filled'"
                                                              v-b-tooltip.hover :title="`$${marketPrices['gold']}`">{{ name | titleCase }}</span>

                                                        <span v-else-if="name === 'diamond' || name === 'melee' ">Diamond</span>
                                                        <span v-else>Non Precious Metals</span>
                                                    </template>

                                                    <template v-else>
                                                        <span>{{(name == "Other" ? "Non Precious Metals" : name) | titleCase }}</span>
                                                    </template>




                                                    <!--<b-badge v-if="(name == 'gold' || name == 'silver' || name == 'platinum' || name == 'palladium') && marketPrices"-->
                                                             <!--pill variant="light" class=""><i class="small">${{ marketPrices[name] }}</i>-->
                                                    <!--</b-badge>-->
                                                </b-th>
                                                <b-th>
                                                    <b-input-group class="table-input m-auto text-right" size="sm"
                                                                   append="%">
                                                        <b-form-input @blur="updateItemPayoutRates(name, $event)"
                                                                      :disabled="!_metal_has_value[name]"
                                                                      v-model="_setMetalPayoutRate[name]"
                                                                      class="text-right"></b-form-input>
                                                    </b-input-group>
                                                </b-th>
                                                <b-th></b-th>
                                            </b-tr>
                                        </template>

                                        <!--id-->
                                        <template v-slot:cell(id)="data">
                                            <b-button variant="link"
                                                      :to="'/appraisals/appraise/'+order.id+'/inventory/'+data.item.id + '?after_save=OfferGen'">
                                                {{ data.item.id }}
                                            </b-button>
                                            <div>{{ data.item.status_name | titleCase }}</div>
                                        </template>

                                        <!--purity-->
                                        <template v-slot:cell(purity)="data">
                                            <span v-if="data.item.children[0]">
                                                <span v-if="(data.item.children[0].purity || data.item.children[0].purity_type)">{{ data.item.children[0].purity }} {{ data.item.children[0].purity_type }}</span>
                                            </span>
                                        </template>
                                        <!--picture-->
                                        <template v-slot:cell(picture)="data">
                                            <div class="pic position-relative pointer" @click="openLightBox(data.item.media)">
                                                <b-badge pill v-if="data.item.media.length > 1" variant="primary" class="position-absolute text-white m-1">
                                                    <i class="fa-solid fa-images "></i> {{ data.item.media.length }}
                                                </b-badge>
                                                <img width="80px"  :src="data.item.media[0] ? data.item.media[0].url : '' " />
                                            </div>
                                        </template>

                                        <!--item details-->
                                        <template v-slot:cell(item_details)="data">
                                            {{ data.item.type.name }}
                                            <div class="font-xxs" v-if="data.item.brand_name">Brand: {{ data.item.brand_name }}</div>

                                            <template
                                                v-if="data.item.children.length > 1 || data.item.type.item_category_id == 13 || data.item.type.item_category_id == 2">
                                                <div>
                                                    <a class="pointer"
                                                       @click="data.toggleDetails"><small>
                                                        <i class="fa-solid text-success"
                                                           :class="data.detailsShowing ? 'fa-minus-circle': 'fa-plus-circle' "></i>
                                                        {{ data.detailsShowing ? 'Hide' : 'Show' }}
                                                        Sub Items</small></a>
                                                    <div v-if="checkForZeroValueEAV(data)">
                                                        <b-badge pill variant="danger" class="px-2 py-1 mt-1"
                                                                 v-b-tooltip.hover title="Diamond component without EAV">
                                                            <i class="fa-solid fa-exclamation-triangle mr-1 small"></i>
                                                            <span class="small font-weight-bold">EVA</span>
                                                        </b-badge>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>

                                        <template v-slot:row-details="data">
                                            <b-container>
                                                <b-row align-h="center">
                                                    <b-col cols="12" class="p-0">

                                                        <!-- Child Items -->
                                                        <b-table
                                                            small
                                                            outlined
                                                            fixed
                                                            bordered
                                                            thead-tr-class="bg-secondary"
                                                            :tbody-tr-class="tableRowVariant"
                                                            class="font-weight-normal"
                                                            :key="index"
                                                            :fields="[
                                                            {key: 'class_name', label: 'type'},
                                                           {key: 'tare_weight', label: 'weight'},
                                                            'quantity',
                                                            {key: 'appraisal.value', label: 'AV'},
                                                            'percentage_rate',

                                                            {key: 'details', label: 'Details'},]"
                                                            :items="data.item.children">
                                                            <!--head and cell styles-->
                                                            <template v-slot:head()="data">
                                                                <small>{{
                                                                        data.label | titleCase
                                                                    }}</small>
                                                            </template>
                                                            <template v-slot:cell()="data">
                                                                <small>{{ (data.value || '-') | titleCase }}</small>
                                                            </template>
                                                            <!--head and cell styles-->

                                                            <template v-slot:cell(tare_weight)="data">
                                                                <small>{{
                                                                        data.value
                                                                    }} {{ data.item.weight_type }}</small>
                                                            </template>

                                                            <template v-slot:cell(percentage_rate)="data">
                                                                <small>{{ calcChildPercentRate(data.item) }}%</small>
                                                            </template>

                                                            <template v-slot:cell(appraisal.value)="data">
                                                                <small>${{ data.value | toFixed2 }}</small>
                                                            </template>

                                                            <!--item details-->
                                                            <template v-slot:cell(details)="data">
                                                                <template v-if="childHasDetails(data.item.category_id)">
                                                                    <i @click="data.toggleDetails"
                                                                       class="fa-solid text-success"
                                                                       :class="data.detailsShowing ? 'fa-minus-circle': 'fa-plus-circle' "></i>
                                                                </template>
                                                                <template v-else-if="isMetal(data.item)">
                                                                    {{data.item.purity}}{{data.item.purity_type == "kt" ? " ": ""}}{{data.item.purity_type}}
                                                                </template>
                                                                <template v-else>
                                                                    -
                                                                </template>

                                                            </template>

                                                            <template v-slot:row-details="data">
                                                                <!--Child Item Details -->
                                                                <b-row v-if="childHasDetails(data.item.category_id)">
                                                                    <b-col offset="3">
                                                                        <b-table small
                                                                                 outlined
                                                                                 fixed
                                                                                 table-variant="info"
                                                                                 thead-tr-class=""
                                                                                 tbody-tr-class=""
                                                                                 class="font-weight-normal"
                                                                                 :key="index"
                                                                                 :fields="childDetailInventoryFields(data.item.category_id)"
                                                                                 :items="[data.item]">

                                                                            <!--head and cell styles-->
                                                                            <template v-slot:head()="data">
                                                                                <small class="">{{
                                                                                        data.label
                                                                                    }}</small>
                                                                            </template>
                                                                            <template v-slot:cell()="data">
                                                                                <small class="font-xxs"
                                                                                       v-if="data.item.category_id === 2">{{
                                                                                        (data.value || '-')
                                                                                    }}</small>
                                                                                <small class="font-xxs" v-else>{{
                                                                                        (data.value || '-') | titleCase
                                                                                    }}</small>
                                                                            </template>
                                                                            <!--head and cell styles-->

                                                                            <!--numismatic-->
                                                                            <template
                                                                                v-slot:cell(appraisal.numismatic)="data">
                                                                                <small class="font-xxs">${{
                                                                                        data.value | toFixed2
                                                                                    }}</small>
                                                                            </template>

                                                                            <!--certificate name-->
                                                                            <template v-slot:cell(certificate_name)="data">
                                                                                <span class="font-xxs">{{ data.value }}</span>
                                                                            </template>

                                                                            <!--total-->
                                                                            <!--<template-->
                                                                                <!--v-slot:cell(appraisal.total)="data">-->
                                                                                <!--<span-->
                                                                                    <!--class="font-xxs">&#45;&#45;&#45;&#45;${{-->
                                                                                        <!--data.value | toFixed2-->
                                                                                    <!--}}</span>-->
                                                                            <!--</template>-->

                                                                        </b-table>
                                                                    </b-col>
                                                                </b-row>

                                                            </template>

                                                        </b-table>

                                                    </b-col>
                                                </b-row>
                                            </b-container>
                                        </template>

                                        <!--quantity-->
                                        <template v-slot:cell(quantity)="data">
                                            <div v-if="data.item.type.item_category_id === 2">
                                                {{ data.item.children[0].quantity }}
                                                <small class="font-weight-normal d-block">Coins/Bullion</small>
                                            </div>
                                            <div v-else>
                                                {{ data.item.quantity }}
                                            </div>

                                        </template>

                                        <!--weight-->
                                        <template v-slot:cell(weight)="data">
                                            {{ data.item.aggregate_dwt }} dwt
                                        </template>

                                        <!--Total-->
                                        <template v-slot:cell(total)="data">
                                            <div class="text-right">
                                                <div class="font-xxs text-muted" v-if="data.item.numismatic_value">
                                                    AV: {{ data.item.appraisal.value + data.item.appraisal.adjustment | toFixed2 }}<br>
                                                    + EAV(P): {{ data.item.numismatic_value | toFixed2}}
                                                    <template v-for="item in data.item.children">
                                                        <div v-if="item.appraisal.numismatic != 0">
                                                            + EAV(C): {{ item.appraisal.numismatic | toFixed2}}
                                                        </div>
                                                    </template>
                                                    <hr class="m-0">
                                                </div>
                                                ${{ data.item.appraisal.total | toFixed2}}
                                            </div>
                                        </template>

                                        <!--offer rate-->
                                        <template v-slot:cell(offer_rate)="data">
                                            <b-input-group size="sm" append="%" class="table-input m-auto">
                                                <b-form-input class="text-right"
                                                              :disabled="data.item.appraisal.value + data.item.appraisal.adjustment + data.item.numismatic_value == 0"
                                                              v-model="data.item.offer_percent"
                                                              @change="setItemAmount(data.item)">
                                                </b-form-input>
                                            </b-input-group>
                                        </template>

                                        <!--offer amount-->
                                        <template v-slot:cell(offer_amount)="data">
                                            ${{ data.item.offer_amount | toFixed2 }}
                                        </template>

                                    </b-table>
                                </b-card>
                            </b-card>

                        </b-card>
                    </b-col>
                </b-row>
            </b-col>


            <b-col cols="3">
                <dashboard-side-data-widget label="Ready For Generation"
                                            :data="dashboardData.ordersOfferGenStatus"
                                            colorData="warning"
                                            icon="fa-light fa-pallet-alt">
                </dashboard-side-data-widget>

                <dashboard-side-data-widget label="Offers Generated"
                                            :data="dashboardData.ordersOfferReadyStatus"
                                            colorData="success"
                                            icon="fa-light fa-box-full">
                </dashboard-side-data-widget>

                <dashboard-side-data-widget label="Orders in Appraisal Hold"
                                            to="/search?filterField_0=status_id&filterModel_0=order&filterName_0=Order%20Status&filterParameter_0=equals&&filterValue_0=6"
                                            :data="dashboardData.ordersHoldStatus"
                                            colorData="danger"
                                            icon="fa-light fa-archive">
                </dashboard-side-data-widget>


                <b-card header="Offer" v-if="offer" :header-class="previous_order_negotiated() ? 'offers-issue-color' : '' " header-class="font-weight-bold" >
                    <b-table-simple small>
                        <b-tbody>
                            <b-tr>
                                <b-th style="border-top: 0;">Cust. Convenience<br>Payment</b-th>
                                <b-td style="border-top: 0;" colspan="2">

                                    <span class="offer-auto-accept"
                                          :class="!order.allow_convenience_accept ? 'strike-through': ''">
                                        {{ order.convenience_accepted_at | datetime }}</span>
                                    <b-form-checkbox
                                        class="customer-convenience-switch"
                                        :class="order.allow_convenience_accept ? 'toggle-success':'toggle-error' "
                                        switch
                                        v-model="order.allow_convenience_accept">
                                    </b-form-checkbox>
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-th>Total Value</b-th>
                                <b-td colspan="2">${{ _getOfferTotal.actual_value | toFixed2 }}</b-td>
                            </b-tr>
                            <b-tr v-if="lastNegotatedOffer" class="offers-issue-color">
                                <b-th>Previous Accepted Offer</b-th>
                                <b-td>${{ lastNegotatedOffer.total_offer | toFixed2 }}</b-td>
                                <b-td>{{ (((lastNegotatedOffer.total_offer + lastNegotatedOffer.bonus_amount)/lastNegotatedOffer.total_value)*100).toFixed(2) }}%</b-td>
                            </b-tr>
                            <b-tr v-else>
                                <b-th>Previous Accepted Offer</b-th>
                                <b-td>n/a</b-td>
                                <b-td>n/a</b-td>
                            </b-tr>
                        </b-tbody>

                    </b-table-simple>

                    <!-- offer table -->
                    <b-table-simple
                        small
                        outlined
                        bordered>
                        <b-tbody class="">
                            <b-tr>
                                <b-th>In Offer Actual</b-th>
                                <b-td>${{ _getOfferTotal.actual_value.toFixed(2) }}</b-td>
                                <b-td></b-td>
                            </b-tr>
                            <b-tr>
                                <b-th>Offer</b-th>
                                <b-td>${{ _getOfferTotal.offer_value.toFixed(2) }}</b-td>
                                <b-td>{{ _getOfferTotal.offer_rate.toFixed(2) }}%</b-td>
                            </b-tr>
                            <b-tr>
                                <b-th class="pl-3">+ bonus</b-th>
                                <b-td>${{ (_getBonusAmount) }}</b-td>
                                <b-td>
                                    <b-select size="sm"
                                              v-model="bonus_percent"
                                              v-on:change="handleBonusSelect()"
                                              :options="[{value:0, text:'0%'},{value:5, text:'5%'},{value:10, text:'10%'}]"
                                    ></b-select>
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-th>Offer Total</b-th>
                                <b-td>
                                    <b-input-group prepend="$" size="sm">
                                        <b-form-input size="sm" @blur="setTotalOfferWithBonusEvent($event)"
                                                      :disabled="_getOfferTotal.actual_value == 0"
                                                      :value="_getOfferTotalWithBonus.toFixed(2)"></b-form-input>
                                    </b-input-group>
                                </b-td>
                                <b-td>
                                    <b-input-group append="%" size="sm">
                                        <b-form-input size="sm" @blur="setTotalPercentOfferWithBonusEvent($event)"
                                                      :disabled="_getOfferTotal.actual_value == 0"
                                                      :value="_getOfferTotalWithBonusRate.toFixed(2)"></b-form-input>
                                    </b-input-group>
                                </b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                    <!--
                    <b-button v-on:click="updateMarket" class="my-2 font-weight-bold" block variant="warning" size="lg"
                                               :disabled="isSaving != false"><i
                        :class="'fa-solid ' + (isSaving == 'market' ? 'fa-spinner fa-spin' : 'fa-dollar-sign')"></i> Update Market Price
                    </b-button> -->
                    <div id = "offer-gen-approve">
                        <b-button v-on:click="approveOffer" class="my-2 font-weight-bold" block variant="success" size="lg"
                                  :disabled="isSaving != false || offergenDisabled"><i
                            :class="'fa-solid ' + ((isSaving == 'approve' ? 'fa-spinner fa-spin' : 'fa-check'))"></i> Approve Offer
                        </b-button>
                        <b-form-checkbox
                            class="customer-convenience-switch mr-1"
                            v-model="offer.send_offer_ready"
                            switch>
                            <b>Notify Customer Via Email</b>
                        </b-form-checkbox>
                    </div>
                    <b-tooltip
                            noninteractive
                            target="offer-gen-approve"
                            v-if="disableExplanation != ''"
                            :variant="'light'">
                        {{ disableExplanation }}
                    </b-tooltip>


                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import _, {assign} from 'lodash';
import DashboardSideDataWidget from '@/components/DashboardSideDataWidget';
import OrderCardHeader from '@/components/OrderCardHeader';
import GenericPopups from '@/components/GenericPopups';
import {BROADCAST_CONNECTED} from '@/store/actions';
import ImageLightBox from '@/components/ImageLightBox.vue';

export default {
    name: 'offer-generation-view',
    components: {
        ImageLightBox,
        DashboardSideDataWidget,
        OrderCardHeader,
        GenericPopups
    },
    data() {
        return {
            marketPrices: {},
            isSaving: false,
            loading: false,
            working: false,
            saving: false,
            order: null,
            customer: null,
            inventory: null,
            offer: null,
            inventoryFields: ['id', 'purity', 'picture', 'item_details', 'quantity', 'weight', 'total', 'offer_rate', 'offer_amount'],
            //bonus_amount: 0, #use offer.bonus_amount
            bonus_percent: 0,
            previous_bonus_percent: 0,
            cachedCustomer: null,
            customer_payment_rate: {
                isEditing: false,
                isSaving: false,
            },
            dashboardData: {
                ordersOfferGenStatus: null,
                ordersOfferReadyStatus: null,
                ordersHoldStatus: null,
            },
            lastNegotatedOffer: null,
            offergenDisabled: false,
            disableExplanation: '',
        };
    },
    created() {
        this.loading = true;
        this.working = true;
        this.$http.get('/orders/' + this.$route.params.id + '/?include=customer.orders,customer.latestRenegotiatedOffer,payments')
            .then(response => {
                this.order = response.data.data;
                this.lastNegotatedOffer = this.order.customer.latestRenegotiatedOffer;
                if(this.order.status_name === 'Offer Generation'
                    || this.order.status_name === 'Offer Ready'
                    || this.order.status_name === 'Offer Accepted'
                    || this.order.status_name === 'Offer Declined'
                    || this.order.status_name === 'Reverse Ship'
                    || this.order.status_name === 'Settled'
                    || this.order.status_name === 'Returned') {
                    this.customer = response.data.data.customer;
                    this.cachedCustomer = Object.assign({}, this.customer);
                    this.$store.commit('setActiveOrder', this.order);

                    this.$http.get('/orders/' + this.$route.params.id + '/createAppraisals')
                        .then(response => {
                            this.handleAppraisalsResponse(response);
                        })
                        .catch((reponse) => {
                            this.$router.push('/offer-generation');
                        });

                    // skip first change in data
                    this.$nextTick(() => {
                        this.loading = false;
                        this.working = false;
                    });
                } else {
                    this.$parent.$bvModal.msgBoxOk('Order must be in Status Offer Generation to generate offers.', {
                        title: 'Invalid Status',
                        size: 'md',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        headerClass: 'p-2 border-bottom-0 text-center d-block',
                        footerClass: 'p-2 border-top-0',
                    });
                    this.$router.push('/offer-generation');
                }
            }).catch(response => {
                this.$router.push('/offer-generation/');
            });
        //this.getInventory();
    },
    mounted() {
        this.getDashboardData();

        console.info(String.fromCodePoint(0x1F6F0) + '%c Broadcast Connected:', 'color:yellow;', this.$store.getters.isBroadcastConnected);
        if (! this.$store.getters.isBroadcastConnected) {
            this.$store.subscribe((mutation) => {
                console.log('%cSubscribe mutation ' + mutation.type, 'color:gray;');
                if (mutation.type === BROADCAST_CONNECTED) {
                    console.info(String.fromCodePoint(0x1F504) + '%c Joining via BROADCAST_CONNECTED mutation.', 'color:green;');
                    this.joinBroadcastChannel();
                }
            });
        } else {
            console.info(String.fromCodePoint(0x2757) + '%c Joining via isBroadcastConnected getter.', 'color:teal;');
            this.joinBroadcastChannel();
        }
    },
    beforeDestroy() {
        console.info(String.fromCodePoint(0x1F44B) + ' Leaving App.OfferGeneration channel from OfferGeneration/index.vue.');
        this.$echo.leaveChannel('App.OfferGeneration');
        this.$barcodeScanner.destroy();
    },
    methods: {
        openLightBox(media) {
            this.$refs.ImageLightBox.showLightBox(media);
        },
        isMetal: function (itemComponent) {
            if (itemComponent && itemComponent.category_id !== null) {
                let category_id = itemComponent.category_id;
                return category_id !== 7 && category_id !== 13 && category_id !== 8 && category_id !== 9 && category_id !== 12 && category_id !== 11;
            }
            return false;
        },
        joinBroadcastChannel: function () {
            console.info(String.fromCodePoint(0x1F91D) + ' Joining App.OfferGeneration channel from OfferGeneration/index.vue.');
            this.$echo.channel('App.OfferGeneration')
                .listen('BroadcastDashboardUpdate', (e) => {
                    this.dashboardData = assign(this.dashboardData, e.payload);
                });
        },
        getDashboardData(){
            this.$http.get('/dashboards/OfferGen').then((response) => {
                this.dashboardData = assign(this.dashboardData, response.data.data);
            });
        },
        tableRowVariant(item) {
            return ( item.category_id == 13 && !item.appraisal.numismatic ) ? 'table-danger' : 'bg-light' ;
        },
        checkForZeroValueEAV(data) {
            return _.some(data.item.children, (item) => {
                // console.log(data.item.id, item, data);
                if(item.category_id == 13  && !(item.appraisal.numismatic)) {
                    // console.log(data.item.appraisal.numismatic, data.item.children.length == 1);
                    if(!(!!data.item.appraisal.numismatic && data.item.children.length == 1)) {
                        this.offergenDisabled = true;
                        this.disableExplanation = "There is a diamond component with no Estimated Additional Value";
                        return true;
                    }
                    return false;
                }
            });
        },
        getFlagsByType(type) {
            return _.filter(this.order.flags,(e)=>{return e.flag_type.id == type && e.cleared_at == null;});
        },
        activateFlag(flag){
            if(flag && flag.id){
                this.$store.commit('setActiveFlag', flag);
            }
        },
        //computed refused to work on update (clear flag).
        previous_order_negotiated: function(){
            return this.getFlagsByType(29).length > 0;
        },
        repair_request_flag: function(){
            return this.getFlagsByType(30).length > 0;
        },
        updateFlag(flag){
            console.log("UPDATED");
            for(let i = 0; i < this.order.flags.length; i++){
                if(this.order.flags[i].id == flag.id){
                    this.order.flags[i] = flag;
                }
            }
            this.$forceUpdate();
        },
        //computed was not functioning on updates
        _quoteFlag(){
            //just referencing order.flags allows vue-js to catch it.
            let flags = this.getFlagsByType(14);//quote flag
            if(flags.length > 0){
                let flag = flags[flags.length-1];
                return flag;
            }
            return {
                note: null,
                id: null,
            };
        },
        calcChildPercentRate(item) {
            let calc = parseFloat(((item.offer_amount / item.appraisal.total) * 100).toFixed(2));
            return (calc ? calc : 0);
        },
        childHasDetails(categoryID) {
            let showDetails;
            switch (categoryID) {
                case 2:
                case 7:
                case 8:
                case 9:
                case 13:
                    showDetails = true;
                    break;
                default:
                    showDetails = false;
            }
            return showDetails;
        },
        childDetailInventoryFields(categoryID) {
            let fields;
            switch (categoryID) {
                case 2:
//                      // coins
                    fields = [
                        {key: 'type_name', label: 'Region'},
                        {key: 'style_name', label: 'Coin Type'},
                        {key: 'quantity', label: 'Quantity'},
                        {key: 'appraisal.numismatic', label: 'EAV'},
                    ];
                    break;
//
                case 13:
                case 7:
                    // Diamonds/Melee & precious stones
                    fields = [
                        {key: 'style_name', label: 'Cut'},
                        {key: 'color_name', label: 'Color'},
                        {key: 'clarity_name', label: 'Clarity'},
                        {key: 'appraisal.numismatic', label: 'EAV'},
                        {key: 'certificate_name', label: 'Certificate Type'},
                        {key: 'certificate_number', label: 'Certificate Number'},
                        { key: 'condition_name', label: 'Condition' },
                    ];
                    break;
                case 8:
                case 9:
                    // Gem/Synthetic
                    fields = [
                        {key: 'type_name', label: 'Item Type'},
                        {key: 'style_name', label: 'Style'},
                    ];
                    break;
            }
            return fields;
        },
        handleAppraisalsResponse(response){
            this.offer = response.data.data;
            //todo backend checks for allow convience accept, incase we have cross order changes to rules.
            //todo disabled the previous rules, I could not find a ticket for it, considered invalid for now.
            this.order.allow_convenience_accept = this.offer.allow_convenience_accept;
            //time check
            let timeValid = false;
            let today = new Date().getHours();
            if (today >= 7 && today < 17) { //between 8am and 5pm
                timeValid = true;
            }
            let hasQuote = this._quoteFlag().id || false;
            let highValue = this.offer.total_value >= process.env.VUE_APP_HIGH_VALUE_OFFER_THRESHOLD;
            let hasPreviousOrder = false;
            for (let i = 0; i < this.order.customer.orders.data.length; i++) {
                //order.status_id >= 8 && order.status_id != 16
                if(this.order.customer.orders.data[i].status_id >= 8 && this.order.customer.orders.data[i].status_id != 16 ) {
                    hasPreviousOrder = true;
                }
            }
            if ((!timeValid || highValue)  && !hasQuote && !hasPreviousOrder) {
                this.offer.send_offer_ready = false;
            } else {
                this.offer.send_offer_ready = true;
            }

            let metals = {};
            let sortedMetals = {};
            let that = this;
            response.data.data.inventory.forEach((item) => {
                if (item.children.length > 1) {
                    this.$set(item, '_showDetails', false);
                }
                 item.children.forEach((a) => {
                    that.$set(a, '_showDetails', true);
                });
                if (item.children[0].class_name in metals) {
                    metals[item.children[0].class_name].push(item);
                } else {
                    metals[item.children[0].class_name] = [];
                    metals[item.children[0].class_name].push(item);
                }
            });

            _.forEach(metals, function (value, key) {
                if(_.isEmpty(that.marketPrices)) {
                    // console.log('empty');
                    // console.log(metals[key][0].appraisal.market_prices)
                    that.marketPrices = metals[key][0].appraisal.market_prices;
                }

                sortedMetals[key] = _.orderBy(metals[key], [function (o) {
                    return parseFloat(o.children[0].purity);
                }], ['desc']);
            });
            if( 'diamond' in sortedMetals && 'melee' in sortedMetals ) {
                sortedMetals.diamond.push(...sortedMetals.melee);
                delete sortedMetals.melee;
            }
            this.inventory = sortedMetals;

            // Set bonus dropdown value
            this.bonus_percent =
                Math.max(0, Math.min(10, Math.round(
                    Math.round(
                        //divide by 5 so the 0,5,10 will become 0,1,2 via rounding, and than restore to 0,5,10 by * 5.
                        this.offer.bonus_amount / this._getOfferTotal.offer_value * 100 / 5) * 5))
                ) || 0;
            // this.handleBonusSelect();
        },
        updateMarket(){
            this.isSaving = 'market';
            this.$http.post('/orders/' + this.$route.params.id + '/regenerateMarket')
                .then(response => {
                    this.handleAppraisalsResponse(response);
                    this.isSaving = false;
                });
        },
        setTotalPercentOfferWithBonusEvent(offer_percent) {
            if (this._getOfferTotal.actual_value > 5) {
                this.setTotalPercentOfferWithBonus(Math.min(offer_percent.target.value, 95));
            } else {
                this.setTotalPercentOfferWithBonus(offer_percent.target.value);
            }
        },
        setTotalOfferWithBonusEvent(offer_total) {
            this.setTotalOfferWithBonus(offer_total.target.value);
        },
        setTotalPercentOfferWithBonus(offer_percent) {
            let offer_total = this._getOfferTotal.actual_value * offer_percent / 100 || 0;
            this.setTotalOfferWithBonus(offer_total);
        },
        setTotalOfferWithBonus(offer_total) {
            let adjusted_offer_total = offer_total;
            if (this._getOfferTotal.actual_value > 5) {
                // If calculated offer total percent is greater than 95, back it off
                // console.log('av greater than 5');
                if (_.round((adjusted_offer_total / this._getOfferTotal.actual_value) * 100, 2) > 95) {
                    // console.log('offer greater than 95');
                    adjusted_offer_total = _.round(this._getOfferTotal.actual_value * 95 / 100, 2) || 0;
                    // console.log(adjusted_offer_total);
                }
            }

            let base = _.round(adjusted_offer_total / (1 + (this.bonus_percent / 100)), 8);

            // this.handleBonusSelect(base);
            this.offer.bonus_amount = _.round(base * this.bonus_percent / 100, 2);

            //handle rare rounding error that would discount a penny.
            base += _.round(adjusted_offer_total - base - this.offer.bonus_amount, 2);
            
            this.setTotalOfferValue(base);
            //handle remainder issue
        },
        setTotalOfferValue(offer_value) {
            let that = this;
            let actual_value = _.round(this.offer.total_value, 2);
            if(actual_value == 0 ) {
                let total = _.sum(_.keys(this.inventory).map((metal) =>{ return that.inventory[metal].length; }));
                let eachValue = _.round(5.0/total, 2);
                //for remainder check
                let firstValuedItem = null;
                _.keys(this.inventory).forEach(function (metal) {
                    that.inventory[metal].forEach(function (item) {
                        item.offer_percent = 0;
                        item.offer_amount = eachValue;
                        firstValuedItem = item;
                        let perChildItem = _.round(eachValue / item.children.length, 2);
                        item.children.forEach(function (item) {
                            item.offer_amount = perChildItem;
                        });
                    });
                });
                //patches remainder issue when being set from global
                let remainder = 5 - this._getOfferTotal.offer_value;
                if (firstValuedItem) {
                    firstValuedItem.offer_amount += remainder;
                }
                this.$forceUpdate();
            } else {
                let percent = _.round(offer_value / actual_value, 8); //4 spaces 2 for whole percents, and 2 for decimal.
                //for remainder check
                let firstValuedItem = null;
                _.keys(this.inventory).forEach(function (metal) {
                    that.inventory[metal].forEach(function (item) {
                        item.offer_percent = percent * 100 || 0;
                        item.offer_amount = _.round(((percent) * parseFloat(item.appraisal.total)), 2) || 0;
                        if (item.appraisal.total > 0) {
                            firstValuedItem = item;
                        }
                        item.children.forEach(function (item) {
                            item.offer_amount = (item.appraisal.total * percent);
                        });
                    });
                });
                //patches remainder issue when being set from global
                let remainder = offer_value - this._getOfferTotal.offer_value;
                if (firstValuedItem) {
                    if (Math.abs(remainder) > 0.01) {
                        firstValuedItem.offer_amount += remainder;
                    }
                }
                this.$forceUpdate();
            }
        },
        handleBonusSelect(offer_value = this._getOfferTotal.offer_value) {
            let bonus_amount = _.round(offer_value * this.bonus_percent / 100, 2);
            let previous_bonus_amount = _.round(offer_value * this.previous_bonus_percent / 100, 2);
            let over95 = (_.round(((offer_value + bonus_amount) / this._getOfferTotal.actual_value) * 100, 2) > 95);

            if ((this.customer.payment_rate > 0 || this.order.offer_quote > 0) && this._getOfferTotal.actual_value > 5) {
                this.setTotalOfferWithBonus(offer_value + (previous_bonus_amount));
            } else if (over95 && this._getOfferTotal.actual_value > 5) {
                this.setTotalOfferWithBonus(offer_value + (bonus_amount));
            } else {
                this.offer.bonus_amount = bonus_amount;
            }
        },
        saveCustomerPayRate() {
            this.cachedCustomer = Object.assign({}, this.customer);
            this.customer_payment_rate.isEditing = false;
        },
        cancelCustomerPayRate() {
            this.customer = Object.assign({}, this.cachedCustomer);
            this.customer_payment_rate.isEditing = false;
        },
        updateItemPayoutRates(metal, e) {
            let that = this;
            // console.log(metal);
            let payoutRate = _.round(e.target.value, 2);
            this.inventory[metal].forEach(function (item) {
                item.offer_percent = payoutRate;
                that.setItemAmount(item);
            });
        },
        approveOffer() {
            if(this.offer.total_offer.toFixed(2) == 5 && this.offer.bonus_amount != 0){
                this.$refs.GenericPopups.displayPermission =
                    {
                        title: 'Your Offer amount is less than $5',
                        permission: 'manage offers',
                        text: 'A 5% bonus should not be applied to offers less than $5.',
                        ok: 'Manager Override', //manager override will do function
                        cancel: 'Ok', //cancel is a 'ok'
                        okAction: () => {
                            this.approveOfferFire();
                        },
                        onClose: () => {
                            this.bonus_percent = 0;
                            // console.log("TEST");
                            this.offer.bonus_amount = 0;
                            this.$forceUpdate();
                        },
                        endPointsLater: ['/offers/' + this.offer.id + '/approve', '/offers/' + this.offer.id + '/accept','/offers/' + this.offer.id + '/decline']
                    };
            } else if (this._offerTotalAmount > this._maxOfferOverride) {
                this.$refs.GenericPopups.displayPermission =
                    {
                        title: 'Your payout percentage requires approval',
                        permission: 'manage offers',
                        text: 'Your payout percentage exceeds the payout thresholds. Please request approval to move forward or adjust by removing a bonus or lowering the payout percentage.',
                        ok: 'Manager Override', //manager override will do function
                        cancel: 'Ok', //cancel is a 'ok'
                        okAction: () => {
                            this.approveOfferFire();
                        },
                        endPointsLater: ['/offers/' + this.offer.id + '/approve', '/offers/' + this.offer.id + '/accept','/offers/' + this.offer.id + '/decline']
                    };
            } else if (_.filter(this.order.payments,(p)=>{return p.status != 'voided';}).length > 0) {
                this.$refs.GenericPopups.displayPermission =
                    {
                        title: 'Previous Payment - Offer Push needs approval.',
                        permission: 'manage offers',
                        text: 'A payment has already been applied to this order. Please request approval to move forward and push a new offer.',
                        ok: 'Manager Override', //manager override will do function
                        cancel: 'Ok', //cancel is a 'ok'
                        okAction: () => {
                            this.approveOfferFire();
                        },
                        endPointsLater: ['/offers/' + this.offer.id + '/approve', '/offers/' + this.offer.id + '/accept','/offers/' + this.offer.id + '/decline']
                    };
            } else {
                this.approveOfferFire();
            }
        },
        approveOfferFire() {
            this.isSaving = 'approve';
            let that = this;
            let offer_items = [];
            _.keys(this.inventory).forEach(function (metal) {
                that.inventory[metal].forEach(function (item) {
                    offer_items.push({
                        'inventory_id': item.id,
                        'offer_id': that.offer.id,
                        'offer_amount': item.offer_amount,
                        'in_offer': true,
                    });
                });
            });
            let send = _.assign({}, this.offer);
            send.offer_items = offer_items;
            send.pushed_date =new Date();
            delete send.inventory;
            send.allow_convenience_accept = this.order.allow_convenience_accept;
            ///orders/{order}/offers
            this.$http.post('/offers/' + this.offer.id + '/approve', send).then(() => {
                this.$store.commit('setActiveOrder', null);
                this.$router.push('/quality-assurance/');
            }).catch((e)=>{this.isSaving = false});
        },
        setItemAmount(item) {
            item.offer_percent = parseFloat(item.offer_percent);
            let newRate = (item.offer_percent / 100) || 0;
            item.offer_amount = _.round(((item.offer_percent / 100) * parseFloat(item.appraisal.total)), 2) || 0;
            item.children.forEach(function (item) {
                item.offer_amount = (item.appraisal.total * newRate) || 0;
            });
        },
        figureOfferAmount(item) {
            console.log(parseFloat(item.offer_amount), parseFloat(item.appraisal.total));
            item.offer_percent = (parseFloat(item.offer_amount) / parseFloat(item.appraisal.total)) * 100 || 0;
        },
        rowClass(item, type) {
            if (!item || type !== 'row') return;
            if (item.status_name === 'hold') return 'table-warning';
        },
        expandAll() {
            _.keys(this.inventory).forEach((metal) => {
                this.inventory[metal].forEach((item) => {
                    item._showDetails = true;
                });
            });
        },
        collapseAll() {
            _.keys(this.inventory).forEach((metal) => {
                this.inventory[metal].forEach((item) => {
                    if (item.children.length > 1) {
                        item._showDetails = false;
                    }
                });
            });
        },
    },
    computed: {
        _offerTotalAmount: function(){
            if(this.offer) {
                return (this.offer.bonus_amount + this.offer.total_offer || 0);
            }
            return 0;
        },
        _isFlagUpdated () {
            return this.$store.getters.updatedFlag;
        },
        _getOfferTotalWithBonus() {
            return (this._getBonusAmount + this._getOfferTotal.offer_value);
        },
        _getOfferTotalWithBonusRate() {
            return (this._getOfferTotalWithBonus / this._getOfferTotal.actual_value) * 100 || 0;
        },
        _getBonusAmount() {
            return this.offer.bonus_amount ? this.offer.bonus_amount : parseFloat((this._getOfferTotal.offer_value * (this.bonus_percent / 100))) || 0;
        },
        _maxOfferOverride() {
            let totalMetal = 0;
            if(this.inventory && this.inventory !== true) {
                _.forEach(this.inventory, (type) => {
                    _.forEach(type, (item) => {
                        console.log("mid_before",totalMetal);
                        if (item.type_name.toLowerCase().includes('bullion')) {
                            totalMetal += parseFloat(item.appraisal.total) * .952;
                        } else {
                            totalMetal += parseFloat(item.appraisal.total) * .902;
                        }
                    });
                });
                return Math.max(totalMetal, 5);
            } else {
                return 0;
            }
        },
        _metal_has_value() {
            let that = this;
            let obj = {};
            _.keys(this.inventory).forEach(function (metal) {
                let m_total = 0;
                let m_offer = 0;
                that.inventory[metal].forEach(function (item) {
                    if (parseFloat(item.offer_amount) > 0 && parseFloat(item.appraisal.total) > 0) {
                        //set each metal offer percent based on total
                        item.offer_percent = _.round((parseFloat(item.offer_amount) / parseFloat(item.appraisal.total) * 100), 2) || 0;
                        //get totals for math
                        m_total += parseFloat(item.appraisal.total);
                        m_offer += parseFloat(item.offer_amount);
                        //percent += item.offer_percent;

                    } else {
                        item.offer_percent = 0;
                    }
                });
                obj[metal] = m_total > 0;
            });
            return obj;
        },
        _setMetalPayoutRate() {
            let that = this;
            let obj = {};
            _.keys(this.inventory).forEach(function (metal) {
                let m_total = 0;
                let m_offer = 0;
                that.inventory[metal].forEach(function (item) {
                    if (parseFloat(item.offer_amount) > 0 && parseFloat(item.appraisal.total) > 0) {
                        //set each metal offer percent based on total
                        item.offer_percent = _.round((parseFloat(item.offer_amount) / parseFloat(item.appraisal.total) * 100), 2) || 0;
                        //get totals for math
                        m_total += parseFloat(item.appraisal.total);
                        m_offer += parseFloat(item.offer_amount);
                        //percent += item.offer_percent;

                    } else {
                        item.offer_percent = 0;
                    }
                });
                obj[metal] = _.round(m_offer / m_total * 100, 2) || 0;
            });
            return obj;
        },
        _getOfferTotal() {
            let that = this;
            let actual_value = _.round(this.offer.total_value, 2);
            let offer_value = 0;
            _.keys(this.inventory).forEach(function (metal) {
                that.inventory[metal].forEach(function (item) {
                    offer_value += _.round(parseFloat(item.offer_amount), 2);
                });
            });
            return {
                actual_value: actual_value,
                offer_value: _.round(offer_value, 2),
                offer_rate: _.round(((offer_value / actual_value) * 100), 2) || 0,
            };
        }
    },
    watch: {
        _isFlagUpdated: {
            immediate: true,
            deep: true,
            handler(flag) {
                this.updateFlag(flag);
                //this.flags = Object.assign([], this.flags);
                this.$forceUpdate();
            }
        },
        'inventory': {
            deep: true,
            handler() {

                let that = this;
                let total_value = 0;
                let offer_value = 0;
                let actual_total_value = 0;
                _.keys(this.inventory).forEach(function (metal) {
                    that.inventory[metal].forEach(function (item) {
                        if (item.in_offer) {
                            offer_value += _.round(parseFloat(item.offer_amount), 2);
                            total_value += _.round(parseFloat(item.appraisal.total), 2);
                        }
                        actual_total_value += _.round(parseFloat(item.appraisal.total), 2);
                    });
                });
                if(this.offer) {
                    this.offer.total_value = _.round(total_value, 2);
                    this.offer.actual_total_value = _.round(actual_total_value, 2);
                    this.offer.total_offer = _.round(offer_value, 2);
                    this.offer.offer_rate = _.round(((offer_value / total_value) * 100), 2);
                }
            }
        },
        bonus_percent(value, oldValue) {
            this.previous_bonus_percent = oldValue;
        },
    }
};
</script>

<style scoped>
.table-input {
    max-width: 80px;
    text-align: right;
}

.table-img {
    max-width: 100px;
}

.editable .controls .fa-solid {
    font-size: 18px;
    transition: .2s ease;
}

.editable .controls .fas:hover {
    transform: scale(1.2);
}

.editable .data {
    position: relative;
}

.editable .data:hover {
    background: #f6f6f6;
    cursor: pointer;
}

.editable .data:hover:after {
    font-family: 'FontAwesome';
    content: "\f14b";
    position: absolute;
    right: 4px;
    top: 0;
    color: lightcoral;
    font-size: 12px;
}
small, .small,
label, .label,
.font-xxs {
    font-size: .7rem !important;
}

.strike-through {
    text-decoration: line-through;
}



</style>